import useTagBiForGeoentity from './useTagBiForGeoentity'
import { SPD_GEOENTITY_LIST_LINK } from '../analytics/BiTagger'
import classNames from 'classnames'
import s from './GeoentityListItem.less'
import RectangleActionButton, {
  COLOR_ORANGE_EMPTY,
  SIZE_MEDIUM
} from '../genericComponents/buttons/RectangleActionButton'
import React from 'react'

export const ReservationButton = ({ reservationUrl, clickTagPropsForRedirection }) => {
  const sendBiTagNow = useTagBiForGeoentity(SPD_GEOENTITY_LIST_LINK, { targeturl: reservationUrl })
  return (
    <span className={classNames(s.button, s.buttonForeground)}>
      <RectangleActionButton
        label="Réserver"
        color={COLOR_ORANGE_EMPTY}
        tagData={clickTagPropsForRedirection}
        href={reservationUrl}
        targetBlank={true}
        nofollow={true}
        onClick={() => {
          sendBiTagNow()
        }}
        size={SIZE_MEDIUM}
      />
    </span>
  )
}
